<script>
import { enumValidator, typographyColorValidator } from "../enumValidator";
import { mergeData } from "vue-functional-data-merge";

const getTagName = props => {
  if (props.tag) {
    return props.tag;
  }

  if (["h6", "h5"].indexOf(props.variant) !== -1) {
    return props.variant;
  }

  return "div";
};

export default {
  functional: true,
  props: {
    /**
     * Sets text variant ["h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button"]
     */
    variant: {
      type: String,
      validator: enumValidator(["h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button"]),
      default: "body1"
    },
    /**
     * Adds bottom gutter
     */
    gutterBottom: {
      type: Boolean,
      default: false
    },
    /**
     * Sets HTML tag for the component
     */
    tag: {
      type: String,
      default: null
    },
    /**
     * Sets text color ["inherit", "text", "medium", "disabled", "primary", "positive", "negative", "on-primary"]
     */
    color: {
      type: String,
      validator: typographyColorValidator,
      default: "text"
    }
  },
  render: function(createElement, context) {
    const { props, data, children } = context;

    return createElement(
      getTagName(props),
      mergeData(data, {
        class: [
          "am-typography",
          `am-typography--color-${props.color}`,
          `am-typography-${props.variant}`,
          {
            "am-typography--gutter-bottom": props.gutterBottom
          }
        ]
      }),
      children
    );
  }
};
</script>
